import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { noteActions } from '_actions';
import { CheckBox, StatusWarning } from '_components';
import styles from './Common.module.css';


class AlTemplateGaitRow extends React.Component {

    render() {
        return (
            <div className={styles.row}>
                <CheckBox
                    size='extra-small'
                    className={styles.checkbox}
                    checked={this.props.activity.selected}
                    title={this.props.desc}
                    label={this.props.desc}
                    onClick={() => this.props.toggleItem({ entity: 'MLTMPGAIT', entityKeyColumn: 'XLTMPGANO', entityKeyValue: this.props.activity.XLTMPGANO })}
                />
                { !this.props.activity.valid &&
                    <span className={styles.warning}>
                        <StatusWarning size='extra-small' title='Not Reimbursable based on Payer/Contract' />
                    </span>
                }
            </div>
        );
    }

}

function mapDispatchToProps(dispatch) {
    return {
        toggleItem: bindActionCreators(noteActions.alTemplateToggleItem, dispatch)
    };
}

function mapStateToProps(state, ownprops) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let activity = state.entities.notes.MLTMPGAIT[ownprops.id];
    let ganame = activity.XLTMPGAGANO ? state.entities.masterData.MLMASTERGAITASSDEV[activity.XLTMPGAGANO].GANAME + ' - ' : '';
    let glname = activity.XLTMPGAGLNO ? state.entities.masterData.MLMASTERGAITLEVASS[activity.XLTMPGAGLNO].GLNAME + ' - ' : '';
    let gsname = activity.XLTMPGAGSNO ? state.entities.masterData.MLMASTERGAITSURFACE[activity.XLTMPGAGSNO].GSNAME + ' - ' : '';
    let act = activity.XLTMPGAACTIVITY ? activity.XLTMPGAACTIVITY + ' - ' : '';
    let distTime = activity.XLTMPGADISTTIME ? activity.XLTMPGADISTTIME + ' - ' : '';
    let desc = ganame + glname + gsname + act + distTime;
    desc = desc.endsWith(' - ') ? desc.slice(0, -3) : desc;

    return {
        noteId: noteId,
        activity: activity,
        desc: desc
    };
}

const connectedAlTemplateGaitRow = connect(mapStateToProps, mapDispatchToProps)(AlTemplateGaitRow);
export { connectedAlTemplateGaitRow as AlTemplateGaitRow };

